import React from "react";
import ContainerHeader from "codeArt/components/ContainerHeader";
import { Page, Refreshable } from "codeArt/components/Base";
import { StatisticsBar } from "app/components/device/StatisticsBar";
import { stopKeepId } from "./constant";
import {
  Grid,
  GridCell,
  GridSection,
  Container
} from "codeArt/components/Layout";
import { DataContext } from "app/data/context";
import { runtime, threePosition, Util } from "codeArt/common";
import { parameterKeepId } from "./constant";
import { getDevice } from "app/constant";
import { DashedPanel } from "codeArt/components/accessory";
import Table from "codeArt/components/accessory/table";
import { Link } from "codeArt/components/Button";
import Modal from "codeArt/components/Modal";

export class Focus extends Refreshable {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      value: null
    };
  }

  renderHeader() {
    return <ContainerHeader hidden={true} sidebar={{ hidden: true }} back={true} />;
  }

  onChange(v) {
    this.setState({
      value: v
    });
  }

  filter({ value, handleChange }) {}

  getExtraClassName() {
    return runtime.mobile ? "c-mx-2d5" : "";
  }

  renderBody() {
    let extraClassName = this.getExtraClassName();
    return (
      <Container innerNarrow={true} scrollable={true}>
        <div className={`d-flex flex-column ${extraClassName}`}>{this.body()}</div>
        <StatisticsBar
          filter={this.filter.bind(this)}
          onChange={v => {
            this.onChange(v);
          }}
        />
      </Container>
    );
  }
}

export function getConsumableImage(name) {
  return require(`./images/${name}.png`);
}

export class Parameter extends React.Component {
  constructor(props) {
    super(props);
  }

  renderCount(row, rowIndex) {
    return (
      <Link
        className="c-text-s2"
        onClick={() => {
          this.modal.open(row);
        }}
      >
        {row.count}
      </Link>
    );
  }

  render() {
    let { mode, reasonData, recordData, title } = this.props;
    return (
      <DashedPanel
        title={title}
        empty={"不适用"}
        className={"w-100"}
        titleClassName={"mt-4 mb-2"}
        line={false}
      >
        <Table
          className="w-100 mt-3"
          scrollable={false}
          columns={[
            { field: "reason", label: "参数", align: "center", width: 4 },
            {
              field: "count",
              label: "更改次数",
              align: "center",
              width: 3,
              component: (row, rowIndex) => {
                return this.renderCount(row, rowIndex);
              }
            },
            {
              field: "last",
              label: "最后一次更改时间",
              align: "center",
              width: 5
            }
          ]}
          data={{ rows: reasonData }}
        />
        <RecordModal
          mode={mode}
          ref={r => {
            this.modal = r;
          }}
          title={"更改记录"}
          data={recordData}
        />
      </DashedPanel>
    );
  }
}

class RecordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      data: []
    };
  }

  open(row) {
    let { mode, data } = this.props;
    if (mode == "weight") {
      if (row.type == 1) this.setState({ data: data[0] });
      if (row.type == 2) this.setState({ data: data[1] });
    } else {
      this.setState({ data: data });
    }

    this.modal.open();
  }

  close() {
    this.modal.close();
  }

  render() {
    let { className, title } = this.props;
    let { data } = this.state;
    return (
      <Modal
        title={title}
        ref={r => {
          this.modal = r;
        }}
        size="md"
      >
        <Table
          className={`w-100 mt-3 mb-3 ${className}`}
          scrollable={false}
          columns={[
            { field: "reason", label: "时间戳", align: "center", width: 6 },
            { field: "new", label: "新值", align: "center", width: 3 },
            { field: "old", label: "旧值", align: "center", width: 3 }
          ]}
          data={{ rows: data }}
        />
      </Modal>
    );
  }
}
